import React, { useEffect, useState, useContext } from 'react'
import { message, Tabs } from 'antd'
import UserTable from '../users/components/userTable'
import UserTableCompany from '../users/components/userTableCompany'
import UserSessionTable from './components/userSessionTable'
import HeaderPage from '../../components/HeaderPage'
import UserDrawer from './components/userDrawer'
import LoadMoreButton from '../../components/LoadMoreButton'
import UserPermissions from './components/userPermissions'
import userSrc from './userSrc'
import UserDrawerMultiempresa from './components/userDrawerMultiempresa'

import { Context, useStore } from '../../context'
import Utils from '../../utils/Utils'

const { TabPane } = Tabs

function Users() {
  const [{ auth }] = useContext(Context)
  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)
  const [dataSource, setDataSource] = useState([])
  const [visible, setVisible] = useState(false)
  const [visibleMultiEmpresa, setVisibleMultiEmpresa] = useState(false)
  const [nextPage, setNextPage] = useState('')
  const [existMoreInfo, setExistMoreInfo] = useState(false)

  const [existMoreInfoSession, setExistMoreInfoSession] = useState(false)
  const [showPermissions, setShowPermissions] = useState(false)
  const [loading, setLoading] = useState(false)
  const [userId, setUserId] = useState(0)
  const [editMode, setEditMode] = useState(false)
  const [editDataDrawer, setEditDataDrawer] = useState(null)
  const [adminTendero, setAdminTendero] = useState(false)
  // Sesion
  const [dataSourceSession, setDataSourceSession] = useState([])
  const [nextPageSession, setNextPageSession] = useState('')
  // AdminEmpresa
  const [dataSourceAdminEmpresa, setDataSourceAdminEmpresa] = useState([])
  const [nextPageAdminEmpresa, setNextPageAdminEmpresa] = useState('')
  const [existMoreInfoAdminEmpresa, setExistMoreInfoAdminEmpresa] = useState(false)
  const [nextPageSessionAdminEmpresa, setNextPageSessionAdminEmpresa] = useState('')
  const [existMoreInfoSessionAdminEmpresa, setExistMoreInfoSessionAdminEmpresa] = useState(false)
  const [loadingAdminEmpresa, setLoadingAdminEmpresa] = useState(false)

  useEffect(() => {
    loadUserData()
    loadUserSessionData()
    loadUserDataAdminEmpresa()
    setAdminTendero(auth?.role?.id === 1)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth])

  const loadUserData = () => {
    setLoading(true)
    setVisible(false)
    setVisibleMultiEmpresa(false)
    userSrc
      .read('', 5, true, 'desc')
      .then(response => {
        setDataSource(getUsers(response))
        setNextPage(response.data.next_page_url)
        setExistMoreInfo(response.data.next_page_url !== null)
        setLoading(false)
      })
      .catch(e => {
        message.error('No se ha podido cargar la información')
        console.log(e)
      })
  }

  const loadUserDataAdminEmpresa = () => {
    userSrc
      .userAdminEmpresa('', 5, true, 'desc')
      .then(response => {
        setDataSourceAdminEmpresa(getUsers(response))
        setNextPageAdminEmpresa(response.data.next_page_url)
        setExistMoreInfoAdminEmpresa(response.data.next_page_url !== null)
        setLoadingAdminEmpresa(false)
      })
      .catch(e => {
        message.error('No se ha podido cargar la información')
        console.log(e)
      })
  }

  const loadUserSessionData = () => {
    setLoading(true)
    setVisible(false)
    setVisibleMultiEmpresa(false)
    userSrc
      .readSession('', 5, true, 'desc')
      .then(response => {
        setDataSourceSession(getUsersSession(response))
        setNextPageSession(response.data.next_page_url)
        setExistMoreInfoSession(response.data.next_page_url !== null)
        setLoading(false)
      })
      .catch(e => {
        message.error('No se ha podido cargar la información')
        console.log(e)
      })
  }

  const EditRow = data => {
    setLoading(true)
    userSrc
      .showUser(data._id)
      .then(response => {
        setEditDataDrawer(getUsers(response, true)[0])
        setEditMode(true)
        setVisible(true)
        setLoading(false)
      })
      .catch(e => {
        message.error('No se ha podido cargar la información')
        console.log(e)
        setLoading(false)
      })
  }

  const EditRowEmpresa = data => {
    setLoading(true)
    userSrc
      .showUser(data._id)
      .then(response => {
        setEditDataDrawer(getUsers(response, true)[0])
        setEditMode(true)
        setVisibleMultiEmpresa(true)
        setLoading(false)
      })
      .catch(e => {
        message.error('No se ha podido cargar la información')
        console.log(e)
        setLoading(false)
      })
  }

  const SessionClose = data => {
    setLoading(true)
    userSrc
      .closeSessionUser(data._id)
      .then(response => {
        loadUserSessionData()
        setLoading(false)
        message.success(`Se ha cerrado la sesión del usuario ${data._name}`)
      })
      .catch(e => {
        message.error('No se ha podido cargar la información')
        console.log(e)
        setLoading(false)
      })
  }

  const getUsers = (users, edit = false) => {
    if (users !== 'Too Many Attempts.') {
      let _users = !edit ? users.data.data || [] : [users]
      return _users.map((d, i) => ({
        key: i,
        _id: d.id,
        _name: d.name,
        _perfilInicialId: d.role !== null && typeof d.role.name !== undefined ? d.role_id : null,
        _perfilInicial: d.role !== null && typeof d.role.name !== undefined ? d.role.name : null,
        level: d.role !== null && typeof d.role.name !== undefined ? d.role.level : null,
        _email: d.email,
        _telefono: d.phone,
        _empresa: d.company !== null && typeof d.company.name !== undefined ? d.company_id : null,
        _empresaNombre: d.company !== null && typeof d.company.name !== undefined ? d.company.name : null,
        _username: d.username,
        _stores_ids: d?.stores || [],
        companies: d?.companies || [],

      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  const getUsersSession = (users, edit = false) => {
    if (users !== 'Too Many Attempts.') {
      let _users = !edit ? users.data.data || [] : [users]
      return _users.map((d, i) => ({
        key: i,
        _id: d.id,
        _name: d.name,
        _username: d.username,
        _updated_at: Utils.formatDateTime(new Date(d.updated_at))
      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  const handlerMoreButton = () => {
    setExistMoreInfo(false)
    if (existMoreInfo) {
      setLoading(true)
      userSrc.userNextPage(nextPage).then(response => {
        setDataSource(dataSource.concat(getUsers(response)))
        setNextPage(response.data.next_page_url)
        setExistMoreInfo(response.data.next_page_url !== null)
        setLoading(false)
      })
    }
  }

  const handlerMoreButtonAdminEmpresa = () => {
    setExistMoreInfo(false)
    if (existMoreInfoAdminEmpresa) {
      setLoading(true)
      userSrc.userNextPage(nextPageAdminEmpresa).then(response => {
        setDataSourceAdminEmpresa(dataSourceAdminEmpresa.concat(getUsers(response)))
        setNextPageAdminEmpresa(response.data.next_page_url)
        setExistMoreInfoAdminEmpresa(response.data.next_page_url !== null)
        setLoadingAdminEmpresa(false)
      })
    }
  }

  const handlerMoreButtonSession = () => {
    setExistMoreInfo(false)
    if (existMoreInfoSession) {
      setLoading(true)
      userSrc.userNextPage(nextPageSession).then(response => {
        setDataSourceSession(dataSourceSession.concat(getUsers(response)))
        setNextPage(response.data.next_page_url)
        setExistMoreInfo(response.data.next_page_url !== null)
        setLoading(false)
      })
    }
  }

  const handlerMoreButtonSessionAdminEmpresa = () => {
    setExistMoreInfoAdminEmpresa(false)
    if (existMoreInfoSessionAdminEmpresa) {
      setLoadingAdminEmpresa(true)
      userSrc.userNextPage(nextPageSessionAdminEmpresa).then(response => {
        setDataSourceAdminEmpresa(dataSourceAdminEmpresa.concat(getUsers(response)))
        setNextPageAdminEmpresa(response.data.next_page_url)
        setExistMoreInfoAdminEmpresa(response.data.next_page_url !== null)
        setLoadingAdminEmpresa(false)
      })
    }
  }

  const searchText = data => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(data)
    userSrc.read(data, 5, excludeChars)
      .then(response => {
        setDataSource(getUsers(response))
        setDataSourceAdminEmpresa(dataSourceAdminEmpresa.concat(getUsers(response)))
        setNextPage(response.data.next_page_url)
        setExistMoreInfo(response.data.next_page_url !== null)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        message.error('Error en la busqueda')
      })
  }

  const searchTextAdminEmpresa = data => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(data)
    userSrc.userAdminEmpresa(data, 5, excludeChars)
      .then(response => {
        setDataSourceAdminEmpresa(getUsers(response))
        setNextPage(response.data.next_page_url)
        setExistMoreInfo(response.data.next_page_url !== null)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        message.error('Error en la busqueda')
      })
  }

  const searchSessionText = data => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(data)
    userSrc.read(data, 5, excludeChars)
      .then(response => {
        setDataSourceSession(getUsers(response))
        setNextPage(response.data.next_page_url)
        setExistMoreInfo(response.data.next_page_url !== null)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        message.error('Error en la busqueda')
      })
  }

  const showDrawer = () => {
    setEditMode(false)
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
    setVisibleMultiEmpresa(false)
  }

  const onCancelButton = () => {
    setVisible(false)
    setVisibleMultiEmpresa(false)
  }

  const checkErrors = res => {
    Object.keys(res.errors).map(key => {
      switch (key) {
        case 'email':
          message.error(res.errors[key][0].replace('email', 'Email'))
          break
        case 'username':
          message.error(res.errors[key][0].replace('username', 'Username'))
          break
        default:
          message.error(res.errors[key])
          break
      }
      return null
    })
  }

  const onSaveButton = (data, user_id, method) => {
    setLoading(true)
    data.user_id = user_id

    switch (method) {
      case 1:
        userSrc.updateUser(data, user_id).then(res => {
          if (res.errors && Object.keys(res.errors)?.length > 0) {
            checkErrors(res)
            setLoading(false)
          } else {
            message.success('Usuario actualizado')
            setVisible(false)
            loadUserData()
          }
        })
        break
      case 2:
        userSrc.saveUser(data).then(res => {
          if (res.errors && Object.keys(res.errors)?.length > 0) {
            checkErrors(res)
            setLoading(false)
          } else {
            message.success('Usuario creado')
            setVisible(false)
            loadUserData()
          }
        })
        break
      case 3:
        userSrc.updateUserCompanies(data, user_id).then(res => {
          if (res.errors && Object.keys(res.errors)?.length > 0) {
            checkErrors(res)
            setLoading(false)
          } else {
            message.success('Usuario actualizado')
            setVisible(false)
            loadUserData()
          }
        })
        break
      case 4:
        userSrc.updateUserCompanies(data, user_id).then(res => {
          if (res.errors && Object.keys(res.errors)?.length > 0) {
            checkErrors(res)
            setLoading(false)
          } else {
            message.success('Usuario creado')
            setVisible(false)
            loadUserData()
          }
        })
        break
      default:
        break
    }
  }

  const DeleteRow = data => {
    setLoading(true)
    userSrc
      .removeUser(data._id)
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          checkErrors(res)
          setLoading(false)
        } else {
          message.success(`${res.name} se ha elminado.`)
          loadUserData()
        }
      })
      .catch(e => {
        console.log(e)
        message.error('Error al eliminar elemento.')
        setLoading(false)
      })
  }

  const editPermissions = data => {
    setUserId(data._id)
    setShowPermissions(true)
  }

  return (
    <div>
      <HeaderPage titleButton={'Nuevo usuario'} title={'Usuarios'} showDrawer={showDrawer} permissions={6} create={auth.company?.allow_add_users} />
      <Tabs id={'tenderoInventoryTabs'} className={'inventory-tab cashRegister-tab'}>
        {hasPermissions([43]) && (
          <TabPane tab="Usuarios" key="1">
            {
              /* <DepositsTab shopsList={shopsList} selectedOption={selectedOption} setSelectedOption={onSelectOption} /> */
              <>
                <UserTable
                  dataSource={dataSource}
                  handlerTextSearch={searchText}
                  loading={loading}
                  handlerEditRow={EditRow}
                  handlerDeleteRow={DeleteRow}
                  handlerEditPermissions={editPermissions}
                />
                <LoadMoreButton handlerButton={handlerMoreButton} moreInfo={existMoreInfo} />
                <UserDrawer
                  closable={onClose}
                  visible={visible}
                  edit={editMode}
                  editData={editDataDrawer}
                  cancelButton={onCancelButton}
                  saveButton={onSaveButton}
                />
                <UserPermissions
                  closable={() => {
                    setShowPermissions(false)
                  }}
                  visible={showPermissions}
                  userId={userId}
                />
              </>
            }
          </TabPane>
        )}
        {hasPermissions([73]) && (
          <TabPane tab="Sesiones abiertas" key="2">
            {
              <>
                <UserSessionTable
                  dataSource={dataSourceSession}
                  handlerTextSearch={searchSessionText}
                  loading={loading}
                  handlerCloseSession={SessionClose}
                />
                <LoadMoreButton handlerButton={handlerMoreButtonSession} moreInfo={existMoreInfoSession} />
              </>
            }
          </TabPane>
        )}
        {hasPermissions([73]) && (
          adminTendero &&
          <TabPane tab="Usuario multiempresa" key="3">
            {
              <>
                <UserTableCompany
                  dataSource={dataSourceAdminEmpresa}
                  handlerTextSearch={searchTextAdminEmpresa}
                  loading={loadingAdminEmpresa}
                  handlerEditRow={EditRowEmpresa}
                  handlerDeleteRow={DeleteRow}
                  handlerEditPermissions={editPermissions}
                />
                <LoadMoreButton handlerButton={handlerMoreButtonAdminEmpresa} moreInfo={existMoreInfoAdminEmpresa} />
                <UserDrawerMultiempresa
                  closable={onClose}
                  visible={visibleMultiEmpresa}
                  edit={editMode}
                  editData={editDataDrawer}
                  cancelButton={onCancelButton}
                  saveButton={onSaveButton}
                />
                <UserPermissions
                  closable={() => {
                    setShowPermissions(false)
                  }}
                  visible={showPermissions}
                  userId={userId}
                />
              </>
            }
          </TabPane>
        )}
      </Tabs>
    </div>
  )
}

export default Users
